export const ARCHIVED_TOOLTIP_MESSAGE = "This to-do has been archived and can no longer be edited.";
export const DOWNLOAD_PERMISSION_MESSAGE = "You don't have permission to download this submission.";
export const READ_ONLY_TOOLTIP_MESSAGE = "You don't have permission to update this to-do.";

export const LOR_TODO_IDS: readonly string[] = [
  "50f7afe0-d500-43f0-b2ac-aea1cb01fbbd",
  "da0d6aeb-baa6-40a6-a812-73a38b22f788",
];

export const LOR_FORM_PATH = "letterOfRecommendationAbroad";

export const RECOMMENDER_NAME_FIELD = "yourName";
export const RECOMMENDER_TITLE_FIELD = "yourProfessionalTitle";
export const RECOMMENDER_ORGANIZATION_FIELD = "yourInstitution";
export const RECOMMENDER_EMAIL_FIELD = "yourEmail";
export const RECOMMENDER_PHONE_FIELD = "yourTelephone";

// Shown in the card header or on the attestation, so they are not question-and-answer rows.
export const NON_QUESTION_FIELDS: readonly string[] = [
  "applicationId",
  RECOMMENDER_NAME_FIELD,
  RECOMMENDER_TITLE_FIELD,
  RECOMMENDER_ORGANIZATION_FIELD,
  RECOMMENDER_EMAIL_FIELD,
  RECOMMENDER_PHONE_FIELD,
  "date",
  "signature",
  "submit",
];
